// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const VolumeIcon = (props: IconProps) => (
  <Icon viewBox="0 0 49 48" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8654 15.9082C24.0353 15.2442 25.4098 16.0852 25.4098 17.3641V30.41C25.4098 31.7503 23.9374 32.441 22.879 31.8734L22.8674 31.8672L22.8674 31.8671L16.9174 28.5309L16.9135 28.5288C16.681 28.3964 16.4029 28.3216 16.0598 28.3216H13.7098C12.7759 28.3216 12.0098 27.5628 12.0098 26.6257V20.6505C12.0098 19.7135 12.7759 18.9546 13.7098 18.9546H16.9598C17.2603 18.9546 17.5866 18.8766 17.8135 18.7475L17.8168 18.7456L17.8168 18.7457L22.8636 15.9093C22.8642 15.9089 22.8648 15.9086 22.8654 15.9082ZM24.0098 17.3641C24.0098 17.15 23.7857 16.9953 23.556 17.126L23.5527 17.1279L23.5527 17.1279L18.506 19.9643C18.5054 19.9646 18.5048 19.965 18.5042 19.9653C18.0315 20.2338 17.4586 20.3546 16.9598 20.3546H13.7098C13.5436 20.3546 13.4098 20.4921 13.4098 20.6505V26.6257C13.4098 26.7841 13.5436 26.9216 13.7098 26.9216H16.0598C16.6158 26.9216 17.137 27.0456 17.6039 27.3108C17.6046 27.3112 17.6053 27.3116 17.606 27.312L23.5447 30.6418C23.6401 30.6911 23.7608 30.6888 23.8657 30.631C23.967 30.5752 24.0098 30.4949 24.0098 30.41V17.3641Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.2747 20.7393C28.6613 20.7393 28.9747 21.0527 28.9747 21.4393V26.4393C28.9747 26.8259 28.6613 27.1393 28.2747 27.1393C27.8881 27.1393 27.5747 26.8259 27.5747 26.4393V21.4393C27.5747 21.0527 27.8881 20.7393 28.2747 20.7393Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.5423 18.7309C32.9289 18.7309 33.2423 19.0443 33.2423 19.4309V28.4309C33.2423 28.8175 32.9289 29.1309 32.5423 29.1309C32.1557 29.1309 31.8423 28.8175 31.8423 28.4309V19.4309C31.8423 19.0443 32.1557 18.7309 32.5423 18.7309Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.8104 16.7226C37.197 16.7226 37.5104 17.036 37.5104 17.4226V30.4226C37.5104 30.8092 37.197 31.1226 36.8104 31.1226C36.4238 31.1226 36.1104 30.8092 36.1104 30.4226V17.4226C36.1104 17.036 36.4238 16.7226 36.8104 16.7226Z"
      fill="currentColor"
    />
  </Icon>
);
